import React from "react";

import { View, StyleSheet } from "@react-pdf/renderer";
import {
  TemplateQuestionFragment,
  ReportMadFragment,
  ReportAnswerFragment,
} from "../../../graphql/fragments";

import {
  isTemplateQuestionTextShort,
  isTemplateQuestionTextLong,
  isTemplateQuestionSelectorSingle,
  isTemplateQuestionSelectorMultiple,
  isTemplateQuestionSkill,
  isTemplateQuestionEvaluation,
} from "../../reports/TemplateQuestionsImpl";

import {
  ReportQuestionTextShort,
  ReportQuestionTextLong,
  ReportQuestionSelectorSingle,
  ReportQuestionSelectorMultiple,
  ReportQuestionEvaluation,
  ReportQuestionSkill,
} from "./ReportQuestionImpl";

export type ReportQuestionEntryProps = {
  mad: ReportMadFragment;
  question: TemplateQuestionFragment;
  answers: ReportAnswerFragment[];
  index: number;
  t: (id: any, options?: {}) => React.ReactNode;
};

export type TemplateQuestionConfig<T extends TemplateQuestionFragment> = {
  Component: React.ElementType<ReportQuestionEntryProps>;
  typeValidator: (q: TemplateQuestionFragment) => q is T;
};

const templateQuestionConfigs: TemplateQuestionConfig<TemplateQuestionFragment>[] = [
  {
    Component: ReportQuestionTextShort,
    typeValidator: isTemplateQuestionTextShort,
  },
  {
    Component: ReportQuestionTextLong,
    typeValidator: isTemplateQuestionTextLong,
  },
  {
    Component: ReportQuestionSelectorSingle,
    typeValidator: isTemplateQuestionSelectorSingle,
  },
  {
    Component: ReportQuestionSelectorMultiple,
    typeValidator: isTemplateQuestionSelectorMultiple,
  },
  {
    Component: ReportQuestionEvaluation,
    typeValidator: isTemplateQuestionEvaluation,
  },
  {
    Component: ReportQuestionSkill,
    typeValidator: isTemplateQuestionSkill,
  },
];

const styles = StyleSheet.create({
  reportSection: {
    flexDirection: "column",
    color: "#2d3748",
    fontSize: "4mm",
    marginTop: "6mm",
    paddingHorizontal: "8mm",
    paddingVertical: "6mm",
    borderRadius: "2mm",
  },
});

const ReportQuestion: React.FC<ReportQuestionEntryProps> = ({
  question,
  ...props
}) => {
  const Config = templateQuestionConfigs.find((c) => c.typeValidator(question));

  if (!Config) return null;
  return (
    <View style={styles.reportSection} wrap={false}>
      <Config.Component question={question} {...props} />
    </View>
  );
};

export default ReportQuestion;
